
import { toRefs } from "vue";
import { ErrorMessage, useField } from "vee-validate";
import { onMounted, onBeforeUnmount, ref } from "vue";
import intlTelInput from "intl-tel-input";
import _ from "lodash";
import { SomeOptions } from "modules/types/public-api";
import { Iso2 } from "intl-tel-input/data";
import { customDictionary, getMatchedLocale } from "@/validation/locales";
import { i18n } from "@/lang";
import "intl-tel-input/build/css/intlTelInput.css";

export default {
  props: {
    name: String,
    disabled: Boolean,
    rules: Object,
    label: {
      type: String,
      required: false
    }
  },
  components: {
    ErrorMessage
  },
  setup(props: any) {
    const { name, rules } = toRefs(props);
    const { value, errors, setErrors, validate } = useField<string | null>(
      name,
      rules,
      { validateOnValueUpdate: false }
    );

    const initialValue = ref(value.value ?? "");

    const phoneInput = ref<HTMLInputElement>();

    const iti = ref<any>();

    const options = _.assign(
      {
        loadUtils: () =>
          require("intl-tel-input/build/js/utils.js?1762589505757"),
        nationalMode: true,
        separateDialCode: true,
        strictMode: true
      },
      initialValue.value
        ? {}
        : {
            initialCountry: "auto",
            geoIpLookup: (callback: (iso2: Iso2) => void) => {
              fetch("https://ipapi.co/json")
                .then(res => res.json())
                .then(data => callback(data.country_code))
                .catch(() => callback("us"));
            }
          }
    ) as SomeOptions;

    onMounted(() => (iti.value = intlTelInput(phoneInput.value!, options)));

    onBeforeUnmount(() => iti.value?.destroy());

    return {
      value,
      errors,
      phoneInput,
      initialValue,
      handleChange: (ev: Event) => {
        initialValue.value = phoneInput.value?.value ?? ""; // workaround to avoid value refreshing
        value.value = phoneInput.value?.value
          ? `${
              options.nationalMode
                ? iti.value?.selectedCountryData?.dialCodePlus ?? ""
                : ""
            }${_.replace(phoneInput.value?.value ?? "", / /g, "")}`
          : "";

        setErrors(
          !iti.value?.isValidNumber() && phoneInput.value?.value
            ? [
                _.replace(
                  customDictionary?.[getMatchedLocale(i18n.global.locale)]
                    ?.phone,
                  "{field}",
                  props.label ?? props.name
                )
              ]
            : []
        );

        if (!errors.value?.length) {
          validate();
        }
      }
    };
  }
};
